import moment from 'moment-timezone';

moment.tz.setDefault('America/Sao_Paulo');

moment.locale('pt-br');

export default {
  methods: {
    formatDateFromNow(dateString) {
      if (!dateString) return null;
      return moment(dateString).fromNow();
    },
    formatDateAsDayMonthAndYear(dateString) {
      if (!dateString) return null;
      return moment(dateString).tz('America/Sao_Paulo').format('DD/MM/YYYY');
    },
    formatDateAsDayMonthAndYearUTC(dateString) {
      if (!dateString) return null;
      return moment(dateString).tz('UTC').format('DD/MM/YYYY');
    },
    formatDateAsString(dateString) {
      if (!dateString) return null;
      return moment(dateString).tz('America/Sao_Paulo').format('DD [de] MMMM / YYYY');
    },
    formatDateDDMMYYYYHHss(dateString) {
      if (!dateString) return null;
      return moment(dateString).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm');
    },
  },
};
